import { render } from "./Error.vue?vue&type=template&id=acd2e3c6&bindings={}"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"
script.render = render

export default script